<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div epub:type="bodymatter">
<section epub:type="division" id="p01">
<div class="dis_img" id="img5"><a id="page4"></a><a id="page5"></a><img alt="" src="Images/5-1.jpg"/>
<p class="caption">During a recording session at the Atlantic Records studio in New York, January 1969.</p>
</div>
<h1 class="part">PART ONE</h1>
<h1 class="part1"><strong>Detroit</strong></h1>
<div class="dis_img01" id="img6"><a id="page6"></a><img alt="" src="Images/6-1.jpg"/>
<p class="caption">A portrait, c. 1964.</p>
</div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454934721_p01.vue?1c1bedf8